module.exports = __webpack_public_path__ + "img/dashboard-placeholder.220e048c.svg";